import dialogReducer from '@/components/dialog'
import { configureStore } from '@reduxjs/toolkit'

export const store = configureStore({
  reducer: {
    dialog: dialogReducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
